export default "__VITE_ASSET__02c1cedf__"